import React from "react";
import { Link } from "react-router-dom";
import isEmpty from "lodash.isempty";

export default ({ companyProfileTypes, onClickDelete }) => {
  const TableOrNotFound = () => {
    if (companyProfileTypes.loading) {
      return "is Loading";
    }
    if (isEmpty(companyProfileTypes.data)) {
      return (
        <p className="is-size-2 has-text-centered has-text-grey">
          Found Nothing
        </p>
      );
    }
    return (
      <table className="table is-fullwidth is-striped is-hoverable">
        <thead>
          <tr>
            <th>ID</th>
            <th>Field Label</th>
            <th>Field Name</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {companyProfileTypes.data.map((companyProfileType) => (
            <tr key={companyProfileType.id}>
              <td>
                <a>{companyProfileType.id}</a>
              </td>
              <td>
                <a>{companyProfileType.label}</a>
              </td>
              <td>
                <a>{companyProfileType.name}</a>
              </td>

              <td className="is-icon">
                <p className="buttons">
                  <Link
                    to={`/company-profile-types/${companyProfileType.id}/edit`}
                    className="button  is-link is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-edit" />
                    </span>
                    <span>Edit</span>
                  </Link>
                  <a
                    onClick={onClickDelete(companyProfileType.id)}
                    to={`/company-profile-types/${companyProfileType.id}/delete`}
                    className="button is-danger is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-trash" />
                    </span>
                    <span>Delete</span>
                  </a>
                </p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  return (
    <section className="section">
      <TableOrNotFound />
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/pages/CompanyProfileType/Index/Table.js